import "../index.scss";
import "./index.scss";
import { getExtraPagesReference } from "helpers/pages";
import {
  getFaqDetailAccordionPreview,
  getFaqTopicPreview,
  getTranslations,
} from "helpers/contenful";
import { logDebug } from "helpers/generic";
import FaqCluster from "pageTemplates/templates/faq/FaqCluster";
import React from "react";

// TODO: check
interface PageTemplateProps {
  page: any;
}

const PageTemplate = ({ page }: PageTemplateProps) => {
  logDebug("Page Faq Cluster->", page);
  const { content } = page;

  const { node_locale, title, subtitle, favuriteFaqs, faqsTopic, pageExtra } =
    content[0];

  // TODO: testing
  const translations =
    pageExtra[0]?.settings[0]?.translations[0]?.translations ?? [];
  const objTranslation = getTranslations(translations, node_locale);

  const listFaqDetailExtraPage = getExtraPagesReference(favuriteFaqs);
  const listFaqDetailPreview = getFaqDetailAccordionPreview(
    listFaqDetailExtraPage,
  );

  const listFaqTopicExtraPage = getExtraPagesReference(faqsTopic);
  const listFaqTopicPreview = getFaqTopicPreview(listFaqTopicExtraPage);

  const data = {
    title,
    subtitle: subtitle?.subtitle ?? "",
    listFaqTopicPreview,
    listFaqDetailPreview,
    translations: objTranslation,
  };

  return <FaqCluster {...data} />;
};

export default PageTemplate;
